import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import {
  actions as bridgeActions,
  selectors as bridgeSelectors
} from "../../../../redux/bridge";
import { actions as modalActions } from "../../../../redux/modals";
import { selectors as licenseSelectors } from "../../../../redux/license";
import { actions as routerActions } from "../../../../redux/router";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { withAllMatches } from "../../../components/mediaquery/breakpoints";
import SmallSubscriptions from "./small-subscriptions";
import DefaultSubscriptionsView from "./default-subscriptions-view";
import LargeBrandedSubscriptionView from "./large-branded-subscription-view";
import { t } from "../../../core/translate";
import PageTitle from "../../../utils/page-title";
import { trendParams } from "../../../../redux/bridge/utils";
import ExploreNullScreen from "./explore-null-screen";
import Footer from "../footer";
import CenteredSpinner from "../../../components/spinner/centered-spinner";
import ExploreNullScreenSearch from "./explore-null-screen-search";
import { studentBannerPadding } from "../../../components/mixins";

const Frame = styled.div`
  ${props => studentBannerPadding(props.showStudentBanner, props.isSmall, props.native)};
`;

const SpinnerContainer = styled.div`
  min-height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
`;

class DefaultView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (!this.props.searchOnly) {
      this.props.fetchLists([trendParams("all", this.props.subscriptionVbid)]);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!this.props.licenseUpdating && prevProps.licenseUpdating) ||
      prevProps.subscriptionVbid !== this.props.subscriptionVbid
    ) {
      this.props.fetchLists([trendParams("all", this.props.subscriptionVbid)]);
    }
  }

  _redeem() {
    this.props.openRedeemModal();
  }

  renderMainContent() {
    const {
      activePromotions,
      allAssets,
      allAssetsLoading,
      goToExplore,
      hasSingleBrandedSubscription,
      searchOnly,
      singleBrandedSubscriptionMode,
      creditCount,
      subscriptionVbid,
      subscriptionVbids,
      subscriptionsLoading,
      isBrandedSubscription,
      brandHasSwimlanes
    } = this.props;

    const hasSingleSub = activePromotions.length + creditCount === 1;
    const validVbid =
      subscriptionVbid ||
      subscriptionVbids[0] ||
      (activePromotions[0] && activePromotions[0].value);

    if (searchOnly) {
      return <ExploreNullScreenSearch />;
    }
    if (allAssetsLoading || subscriptionsLoading) {
      return (
        <SpinnerContainer>
          <CenteredSpinner />
        </SpinnerContainer>
      );
    }
    if (allAssets.length === 0) {
      return <ExploreNullScreen />;
    }
    if (!brandHasSwimlanes) {
      return (
        <SmallSubscriptions
          subscriptionVbid={validVbid}
          allAssetsLoading={allAssetsLoading}
          assets={allAssets}
        />
      );
    }
    if (isBrandedSubscription(validVbid)) {
      if (
        singleBrandedSubscriptionMode === "LANES" ||
        (hasSingleSub && validVbid && allAssets.length > 20)
      ) {
        return <LargeBrandedSubscriptionView subscriptionVbid={validVbid} />;
      }
      if (
        singleBrandedSubscriptionMode === "GRID" ||
        (hasSingleSub && validVbid && allAssets.length <= 20)
      ) {
        return (
          <SmallSubscriptions
            subscriptionVbid={validVbid}
            allAssetsLoading={allAssetsLoading}
            showSearch={hasSingleBrandedSubscription}
            assets={allAssets}
            backToExplore={!hasSingleSub && goToExplore}
          />
        );
      }
    }
    if (allAssets.length <= 20) {
      return (
        <SmallSubscriptions
          subscriptionVbid={validVbid}
          allAssetsLoading={allAssetsLoading}
          assets={allAssets}
        />
      );
    }

    return <DefaultSubscriptionsView {...this.props} />;
  }

  render() {
    const { enableStudentBanner, isSmall, native } = this.props;
    return (
      <Frame showStudentBanner={enableStudentBanner} isSmall={isSmall} native={native}>
        <PageTitle title={t("page.explorer", "Explore")} key="title" />
        {this.renderMainContent()}
        <Footer redeem={() => this._redeem()} offset="0" />
      </Frame>
    );
  }
}

const mapStateToProps = (state, props) => ({
  allAssetsLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("all", props.subscriptionVbid)
  ),
  allAssets: bridgeSelectors.getAssets(
    state,
    trendParams("all", props.subscriptionVbid)
  ),
  subscriptionsLoading: bridgeSelectors.isUserFetching(state),
  licenseUpdating: licenseSelectors.isLicenseUpdating(state),
  searchOnly: brandSelectors.getBrandValue(
    state,
    "Subscriptions.searchOnly",
    false
  ),
  hasSingleBrandedSubscription: bridgeSelectors.hasSingleBrandedSubscription(
    state
  ),
  singleBrandedSubscriptionMode: bridgeSelectors.getSingleBrandedSubscriptionMode(
    state,
    props.subscriptionVbid
  ),
  creditCount: bridgeSelectors.getCreditCount(state),
  subscriptionVbids: bridgeSelectors.getUserSubscriptionVbids(state),
  activePromotions: bridgeSelectors.getActivePromotions(state),
  isBrandedSubscription: vbid =>
    bridgeSelectors.isBrandedSubscription(state, vbid),
  brandHasSwimlanes: brandSelectors.brandHasSwimlanes(state),
  enableStudentBanner: brandSelectors.getBrandValue(state, "StudentHome.enabled")
});

const mapDispatchToProps = dispatch => ({
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists)),
  openRedeemModal: () => dispatch(modalActions.openRedeemModal()),
  goToExplore: () => dispatch(routerActions.replaceRoute("explore"))
});

export default withAllMatches(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(DefaultView))
);
